module.exports = __webpack_public_path__ + "static/media/valor1.e6b11e00.png";